<app-dialog-container (onClose)="closeDialog()">
    <div class="flex flex-col lg:min-h-[600px] min-h-[80vh] justify-center gap-6 md:px-0 sm:px-6">
        <form [formGroup]="applyForm" *ngIf="!submitted" class="w-full">
            <div class="md:max-h-[50vh] max-h-[80vh] overflow-y-auto px-4 sm:px-6">
                <h1 class="text-3xl font-bold text-gray-900 mb-2">{{ job.title }}</h1>
                <p *ngIf="error" class="text-red-500 block text-sm font-medium leading-6 mb-6 bg-red-50 p-4 rounded-lg" i18n>
                    Sorry, there was an issue processing your application. Please check your submission and try again
                    shortly.
                </p>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4 border-b border-gray-200 pb-8">
                    <div class="form-group mb-4">
                        <label for="firstName" class="block text-sm font-medium text-gray-700 mb-1" i18n>First Name<sup class="text-red-500">*</sup></label>
                        <input
                            formControlName="firstName"
                            placeholder="Your Name"
                            required
                            class="block w-full rounded-lg border-0 py-2.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="!applyForm.get('firstName')?.pristine && applyForm.get('firstName')?.hasError('required')"
                            class="text-red-500 text-sm mt-1.5">
                            You must enter your first name.
                        </div>
                    </div>
                    <div class="form-group mb-4">
                        <label for="lastName" class="block text-sm font-medium text-gray-700 mb-1" i18n>Last Name(s)<sup class="text-red-500">*</sup></label>
                        <input
                            formControlName="lastName"
                            placeholder="Your Name"
                            required
                            class="block w-full rounded-lg border-0 py-2.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="!applyForm.get('lastName')?.pristine && applyForm.get('lastName')?.hasError('required')"
                            class="text-red-500 text-sm mt-1.5">
                            You must enter your last name(s).
                        </div>
                    </div>
                    <div class="form-group mb-4">
                        <label for="email" class="block text-sm font-medium text-gray-700 mb-1" i18n>Email Address<sup class="text-red-500">*</sup></label>
                        <input
                            formControlName="email"
                            placeholder="Email Address"
                            required
                            class="block w-full rounded-lg border-0 py-2.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="!applyForm.get('email')?.pristine && applyForm.get('email')?.hasError('required')"
                            class="text-red-500 text-sm mt-1.5">
                            You must enter your email address.
                        </div>
                        <div
                            *ngIf="!applyForm.get('email')?.pristine && !applyForm.get('email')?.hasError('required') && applyForm.get('email').hasError('email')"
                            class="text-red-500 text-sm mt-1.5">
                            You must enter a valid email address.
                        </div>
                    </div>
                    <div class="form-group mb-4">
                        <label for="phone" class="block text-sm font-medium text-gray-700 mb-1" i18n>Telephone Number</label>
                        <input
                            formControlName="phone"
                            placeholder="Telephone Number"
                            class="block w-full rounded-lg border-0 py-2.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                    <div *ngIf="job?.showLocationField" class="form-group mb-4">
                        <label for="location" class="block text-sm font-medium text-gray-700 mb-1" i18n>Your location</label>
                        <input
                            formControlName="location"
                            placeholder="Your Location"
                            class="block w-full rounded-lg border-0 py-2.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                    <div *ngIf="job?.showProfileField" class="form-group mb-4">
                        <label for="profileUrl" class="block text-sm font-medium text-gray-700 mb-1" i18n>Profile URL (e.g. LinkedIn)</label>
                        <input
                            formControlName="profileUrl"
                            placeholder="Your Profile URL"
                            class="block w-full rounded-lg border-0 py-2.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>

                <div class="mt-8 border-b border-gray-200 pb-8">
                    <div class="form-group">
                        <label for="cv" class="block text-sm font-medium text-gray-700 mb-1" i18n>Your CV/Resume<sup *ngIf="!this.job.delayCvOnMobile" class="text-red-500">*</sup></label>
                        <div class="mt-2 flex items-center gap-x-3">
                            <div *ngIf="applyForm.get('cv').value?.filename" class="flex items-center gap-2 text-sm text-gray-700 bg-green-50 border border-green-200 rounded px-3 py-2">
                                <svg class="h-5 w-5 text-green-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                                </svg>
                                <span class="font-medium">{{ applyForm.get('cv').value?.filename }}</span>
                                <span class="text-gray-400" *ngIf="applyForm.get('cv').value?.uploaded">uploaded {{ applyForm.get('cv').value?.uploaded | date : 'short' }}</span>
                            </div>
                            <label class="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500">
                                <span *ngIf="!applyForm.get('cv').value?.filename">Upload a file</span>
                                <span *ngIf="applyForm.get('cv').value?.filename">Change file</span>
                                <input type="file" class="sr-only" (change)="onFileUpload($event)" />
                            </label>
                        </div>
                        <div
                            *ngIf="!applyForm.pristine && applyForm.get('cv')?.hasError('required')"
                            class="text-red-500 text-sm mt-1.5">
                            You must upload your CV/Resume.
                        </div>
                    </div>
                </div>

                <div *ngIf="sanitisedSkills.length" class="mt-8 border-b border-gray-200 pb-8">
                    <h3 class="text-lg font-semibold text-gray-900 mb-4" i18n>Level Of Experience</h3>
                    <p class="text-sm text-gray-500 mb-6" i18n>
                        Please indicate your approximate level of experience in the following areas.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div class="form-group" *ngFor="let skill of sanitisedSkills; let i = index" formGroupName="skills">
                            <label class="block text-sm font-medium text-gray-700 mb-1">{{ job.skills[i] }}</label>
                            <select
                                [formControlName]="skill"
                                class="mt-1 block w-full rounded-lg border-0 py-2.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
                                <option [value]="1" i18n>No experience</option>
                                <option [value]="2" i18n>Some basic experience</option>
                                <option [value]="3" i18n>Average</option>
                                <option [value]="4" i18n>Advanced</option>
                                <option [value]="5" i18n>Expert</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div *ngIf="customQuestionsArr?.length" class="mt-8 border-b border-gray-200 pb-8">
                    <h3 class="text-lg font-semibold text-gray-900 mb-4" i18n>Additional screening questions</h3>
                    <p class="text-sm text-gray-500 mb-6" i18n>
                        Please answer the following additional screening questions.
                    </p>
                    <div class="grid grid-cols-1 gap-6">
                        <div
                            *ngFor="let item of customQuestionsArr.controls; let i = index"
                            formArrayName="customQuestions"
                            class="form-group">
                            <div *ngIf="item.get('type').value === 'text'" [formGroupName]="i">
                                <label class="block text-sm font-medium text-gray-700 mb-1">{{ item.get("question").value }}</label>
                                <input
                                    formControlName="answer"
                                    placeholder="Your Answer"
                                    class="block w-full rounded-lg border-0 py-2.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                            </div>
                            <div
                                *ngIf="item.get('type').value === 'checkbox'"
                                [formGroupName]="i"
                                class="relative flex items-start">
                                <div class="flex h-6 items-center">
                                    <input
                                        type="checkbox"
                                        formControlName="answer"
                                        class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                                </div>
                                <div class="ml-3 text-sm leading-6">
                                    <label class="font-medium text-gray-900">{{ item.get("question").value }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-8 space-y-6">
                    <div class="relative flex items-start" *ngIf="job.rightToWorkInUK">
                        <div class="flex h-6 items-center">
                            <input
                                type="checkbox"
                                formControlName="rightToWorkInUK"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                        </div>
                        <div class="ml-3 text-sm leading-6">
                            <label class="font-medium text-gray-900" i18n>Do you have the right to work in the advertised location?</label>
                        </div>
                    </div>

                    <div *ngIf="job.showSimilarJobsConsent" class="relative flex items-start">
                        <div class="flex h-6 items-center">
                            <input
                                type="checkbox"
                                formControlName="relatedJobsConsent"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                        </div>
                        <div class="ml-3 text-sm leading-6">
                            <label class="font-medium text-gray-900" i18n>
                                Can <span *ngIf="(client$ | async)?.onBehalfOf">{{(client$ | async).onBehalfOf}} </span>
                                <span *ngIf="!(client$ | async)?.onBehalfOf">{{ (client$ | async)?.displayName || (client$ | async)?.name }} </span> contact you
                                in the future about other roles similar to this?
                            </label>
                        </div>
                    </div>

                    <div class="relative flex items-start">
                        <div class="flex h-6 items-center">
                            <input
                                formControlName="terms"
                                type="checkbox"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                        </div>
                        <div class="ml-3 text-sm leading-6">
                            <label class="font-medium text-gray-900" i18n>I have read and agree to the terms of use and privacy statements.<sup class="text-red-500">*</sup></label>
                            <p class="text-gray-500 mt-2" *ngIf="(client$ | async)?.terms">
                                <span *ngIf="(client$ | async)?.onBehalfOf">{{(client$ | async).onBehalfOf}} are managing this role on behalf of {{ (client$ | async)?.displayName || (client$ | async)?.name }}. Their </span>
                                <span *ngIf="!(client$ | async)?.onBehalfOf">{{ (client$ | async)?.displayName || (client$ | async)?.name }}'s </span>
                                <a class="text-indigo-600 hover:text-indigo-500 font-medium" [href]="(client$ | async)?.terms" rel="nofollow" target="_blank">terms</a>
                                can be found here.
                            </p>
                            <p class="text-gray-500 mt-2">
                                Voyse's
                                <a class="text-indigo-600 hover:text-indigo-500 font-medium" href="http://www.voyse.co.uk/terms" rel="nofollow" target="_blank">terms</a>
                                and
                                <a class="text-indigo-600 hover:text-indigo-500 font-medium" href="http://www.voyse.co.uk/privacy" rel="nofollow" target="_blank">privacy</a>
                                statements can be found here.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-8 px-4 sm:px-6">
                <button
                    class="w-full md:w-auto inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-indigo-300 disabled:cursor-not-allowed transition-colors duration-200"
                    [disabled]="submitting || applyForm.invalid"
                    (click)="apply()"
                    i18n>
                    <svg
                        *ngIf="submitting"
                        class="animate-spin -ml-1 mr-2 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24">
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"></circle>
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ job.active ? "Submit Application" : "Register Interest" }}
                </button>
            </div>
        </form>

        <div class="text-center prose max-w-none px-4 sm:px-6" *ngIf="submitted && !finalised">
            <h1 class="text-3xl font-bold text-gray-900 mb-4" i18n>How did we do?</h1>
            <p class="text-lg text-gray-600 mb-8" i18n>
                Good luck with your application! How did you find your candidate experience using Voyse today? Please rate your experience as a candidate below.
            </p>
            <app-star-rating></app-star-rating>
        </div>

        <div class="text-center prose max-w-none px-4 sm:px-6" *ngIf="submitted && finalised">
            <h1 class="text-3xl font-bold text-gray-900 mb-4" i18n>Good luck!</h1>
            <p class="text-lg text-gray-600 mb-6" i18n>
                Thank you for submitting your application for the
                <span class="font-bold">{{ job.title }}</span> position.
            </p>
            <p class="text-lg text-gray-600 mb-6" i18n>
                We really appreciate the time and effort you've invested in applying for this position and understand
                the importance of this opportunity to you.
            </p>
            <p class="text-lg text-gray-600 mb-6" i18n>
                Rest assured; your application will be given the attention it deserves. If your skills and experience
                align with our requirements, we will reach out to you to explain the next steps in the selection
                process. In the interim, feel free to explore more about our company on our website to gain further
                insight into our values and objectives.
            </p>
            <p class="text-lg text-gray-600 mb-6" i18n>
                Thank you once again for your application. We appreciate your patience and look forward to the
                possibility of working together.
            </p>
        </div>
    </div>
</app-dialog-container>
